import { Skeleton, Table } from '@factorialco/deprecated-design-system'
import type { ComplaintsCategoriesQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import CategoriesTableBody from './CategoriesTableBody'

interface Props {
  categories: ComplaintsCategoriesQuery['complaints']['categoriesConnection']['nodes']
  loading: boolean
}

export default function CategoriesTable({ categories, loading }: Props) {
  return (
    <Table overflowY="auto" maxHeight="s400">
      <Table.Head>
        <Table.Row>
          <Table.HeadCell colSpan={6}>
            {i18n.t('app_store_v2.apps.complaints.settings.categories.table.category')}
          </Table.HeadCell>
          <Table.HeadCell colSpan={3} />
          <Table.HeadCell colSpan={3} />
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {loading ? (
          <Table.Row>
            <Table.Cell colSpan={6}>
              <Skeleton height="s16" width="s120" />
            </Table.Cell>
            <Table.Cell colSpan={3}>
              <Skeleton height="s16" width="s80" />
            </Table.Cell>
            <Table.Cell colSpan={3}>
              <Skeleton height="s16" width="s96" />
            </Table.Cell>
          </Table.Row>
        ) : (
          <CategoriesTableBody categories={categories} />
        )}
      </Table.Body>
    </Table>
  )
}
